export class FiltrosRepMarketing{
   
    Usuario : string ='';
    Estado: string = '';
    Tipo: string = 'empresa_cliente';
 
 }